import { Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { prettyPrintMonthYear } from "util/dates";

import { formatPounds } from "../../EpisodicEvents/episodicDisplay";

type MonthRow = { month: string; episodicExemptPounds?: number | null };

export function EpisodicExemptFootnotes({
  rows,
  tenantId,
  facilityId,
}: {
  rows: readonly MonthRow[];
  tenantId: string | undefined;
  facilityId: string | undefined;
}) {
  const exemptRows = rows.flatMap(({ month, episodicExemptPounds }) =>
    episodicExemptPounds && episodicExemptPounds > 0 ? [{ month, episodicExemptPounds }] : []
  );
  if (exemptRows.length === 0) return null;

  return (
    <Stack gap={0.5} sx={{ pt: 1 }}>
      {exemptRows.map(({ month, episodicExemptPounds }) => (
        <Typography key={month} variant="caption" color="text.secondary">
          {prettyPrintMonthYear(month)}: {formatPounds(episodicExemptPounds)} of shipped waste
          excluded as episodic.{" "}
          <Link
            component={RouterLink}
            to={`/o/${tenantId}/waste/episodic-events?facilityId=${facilityId}`}
          >
            View episodic events
          </Link>
        </Typography>
      ))}
    </Stack>
  );
}
